import * as React from 'react';
import { CameraMenuList } from './CameraMenuList';
import { CameraGroup, type ICameraMenuGroupProps, type ICameraMenuGroupState } from './Cameras.types';

export class CameraMenuGroup extends React.Component<ICameraMenuGroupProps, ICameraMenuGroupState> {
    constructor(props: ICameraMenuGroupProps) {
        super(props);

        let groupnameopen = '';

        if (props.currentArea !== undefined && props.currentArea.length > 0) {
            groupnameopen = props.currentArea;
        } else if (props.currentRoad !== undefined && props.currentRoad.length > 0) {
            groupnameopen = props.currentRoad;
        }

        this.state = { groupnameopen };
    }

    public render(): JSX.Element {
        if (this.props.groups === null) {
            return null;
        }

        return <ul className="side-navigation-submenu__list">{this.props.groups.map(this.renderGroup.bind(this))}</ul>;
    }

    private setOpenItem = (event: React.MouseEvent<HTMLDivElement>, url: string) => {
        event.preventDefault();
        const key = (event.currentTarget as HTMLElement).dataset.key;
        this.setState({ groupnameopen: key });
        window.location.href = url;
    };

    private renderGroup(group: CameraGroup, index: number): JSX.Element {
        let toogleDivClassName = 'side-navigation-subsubmenu collapse';
        let carretClassName = '';
        let containerClassName = '';
        let menugroupCount = 'side-navigation-submenu__item-count';
        let liClassName = 'side-navigation-submenu__item';

        if (this.state.groupnameopen === group.key) {
            toogleDivClassName += ' show ';
            carretClassName = 'icon-sort-down icon-rotate-270';
        }

        const anyCameraSelected = group.cameras.some((camera) => camera.isCurrent === true);

        if (this.state.groupnameopen === group.key) {
            containerClassName = 'side-navigation-submenu__item-row--selected';
            menugroupCount += ' side-navigation-submenu__item-count--active';
            liClassName += ' menu-group-list-activated';

            if (anyCameraSelected) {
                carretClassName = 'icon-sort-down';
            }
        }

        return (
            <li key={index} className={liClassName}>
                <div
                    data-key={group.key}
                    className={'side-navigation-submenu__item-row d-flex justify-content-between align-items-center ' + containerClassName}
                    onClick={(e) => this.setOpenItem(e, group.url)}
                    style={{ cursor: 'pointer' }}
                >
                    <a className="side-navigation-submenu__link" href={group.url} onClick={(e) => e.preventDefault()}>
                        <span className={carretClassName} title={carretClassName === 'icon-sort-down' ? 'Markör stängd' : 'Markör öppen'} />
                        <span>{group.key}</span>
                    </a>
                    <span className={menugroupCount}>{group.cameras.length}</span>
                </div>
                <div className={toogleDivClassName}>
                    <CameraMenuList
                        cameras={group.cameras}
                        currentRegion={this.props.currentRegion}
                        currentArea={group.type === 'area' ? group.key : null}
                        currentRoad={group.type === 'road' ? group.key : null}
                    />
                </div>
            </li>
        );
    }
}
